import React from 'react';
import { Image, Text, View } from 'react-native';
import { img_collapse, img_go } from '../../../../utils/ImagesManagementUtils';
import { textPrimary_10_3, textPrimary_20_9, textSecondary_8_0 } from '../TextComponent/TextStyle';

const AmountComponent = ({
  globJSON, IconBackgroundColor = globJSON.configurations.theme.colors.border_color,
  priceAmount,
  colorText = globJSON.configurations.theme.colors.secondary_font_color,
  amountColor = globJSON.configurations.theme.colors.primary_font_color,
  showConvert, isErrorLine, simPlatform,
  enable_select_currency, showAccountBalance,
}) => {
  const myStyles = {
    Amount: {
      fontSize: 20.9,
      fontWeight: 500,
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: 'normal',
      letterSpacing: 'normal',
      color: amountColor,
    },
    Enter_between_1000: {
      width: 'auto',
      marginTop: showAccountBalance ? 7 : 23,
      textAlign: 'center',
      color: isErrorLine ? 'red' : colorText,
    },
    amountViewStyle: {
      justifyContent: 'flex-end',
      paddingEnd: 20,
      flexDirection: 'row',
      alignItems: 'center',
      marginTop: showAccountBalance ? 3 : 15,
    },
    iconStyle: {
      width: 30,
      height: 30,
      backgroundColor: IconBackgroundColor,
      borderRadius: globJSON.configurations.theme.radius.elements_shape_square ? 3 : 15,
      justifyContent: 'center',
      alignItems: 'center',
    },
    priceStyle: {
      paddingHorizontal: '15%',
      flexDirection: 'row',
      alignItems: 'center',
    },
    selectCurrencyStyle: {
      padding: 5,
      marginEnd: 10,
      borderRadius: 2.9,
      backgroundColor: globJSON.configurations.theme.colors.light_elements_color,
      flexDirection: 'row',
      alignItems: 'center',
    },
    selectCurrencyImage: {
      width: 7,
      height: 7,
      marginEnd: 5,
      tintColor: globJSON.configurations.theme.colors.tertiary_icons_color,
    },
  };
  return (
    <View>
      <View style={myStyles.amountViewStyle}>
        {enable_select_currency
                && (
                <View style={myStyles.selectCurrencyStyle}>
                  <Image
                    fadeDuration={0}
                    style={myStyles.selectCurrencyImage}
                    source={img_collapse}
                  />
                  <Text style={[textPrimary_10_3(globJSON, simPlatform), { color: amountColor }]}>$</Text>
                </View>
                )}
        <View style={myStyles.priceStyle}>
          {!enable_select_currency
                    && <Text style={[textPrimary_20_9(globJSON, simPlatform), { color: amountColor }]}>$</Text>}
          <Text style={[textPrimary_20_9(globJSON, simPlatform), { color: amountColor }]}>{priceAmount}</Text>
        </View>
        <View
          style={myStyles.iconStyle}
        >
          <Image
            fadeDuration={0}
            style={{
              width: 17,
              height: 17,
              tintColor: globJSON.configurations.theme.colors.cta_font_color,
            }}
            source={img_go}
          />
        </View>
      </View>
      {showConvert && (
        <Text style={[textSecondary_8_0(globJSON, simPlatform), myStyles.Enter_between_1000]}>
          {showConvert}
        </Text>
      ) }
    </View>
  );
};
export default AmountComponent;
